// extracted by mini-css-extract-plugin
module.exports = {"title":"UserMeta_title__2Uwyt","date":"UserMeta_date__3vvgn","container":"UserMeta_container__1f_cJ","avatar":"UserMeta_avatar__16oxL","meta":"UserMeta_meta__FbXLA"};